import RiveComponent from '@rive-app/react-canvas'; // { useRive }
import { rewardClaimRes } from '@/types';
import { Button } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
// import {
//   // useEffect,
//   // useMemo,
// } from
// 'react';
import styles from './style.module.scss';
import { CloseIcon } from '@bfe/moly-icons';
import {
  replaceBybitToLocationHost,
  relativeToAbsolute,
  appPath,
} from '@web3/base-utils';

type IDrawResult = {
  visible: boolean;
  result: rewardClaimRes | null;
  onOk: () => void;
  onCancel: () => void;
  onShare: () => void;
};

export function DrawResult(props: IDrawResult) {
  const { visible, result } = props;
  const fm = useFm();

  // const result = useMemo(
  //   () => ({
  //     rewardStatus: 1,
  //     rewardInfo: {
  //       rewardIconUrl:
  //         'https://static.bymj.io/bhop/image/ddpAqqEFkNBahxBA6H1AYMHUYd0db1oAhXiK7h5VvyQ.jpeg',
  //       rewardContent: '0.5',
  //       rewardSymbol: 'ETH',
  //     },
  //   }),
  //   []
  // );

  const drawNoWin = relativeToAbsolute(
    'https://fh-static.bycsi.com/draw-failed-4f771a29225aeda64581e9615bbc08d0.png'
  );

  const winSubTilte = fm('congratulationsYouveWon');
  const failTitle = fm('sorryYouDidntWin');
  // const failSubTitle = fm('betterLuckNextTime');

  return (
    visible && (
      <div className={`${styles['draw-wrap']}`}>
        <div className={`${styles['draw-content']} text-center px-4`}>
          <CloseIcon
            onClick={props.onCancel}
            className={`${styles['draw-close']}`}
          />
          <div className={`${styles['draw-result-cont']} mt-6`}>
            {Boolean(result?.rewardStatus) && (
              <p className="text-white text-lg font-normal mt-2">
                {winSubTilte}
              </p>
            )}
            {result?.rewardStatus ? (
              <div className="relative flex justify-center">
                <div className={`${styles['draw-win-token']}`}>
                  <div className={`${styles['token-img']} w-30 h-30`}>
                    <img
                      className="w-24 h-24"
                      src={replaceBybitToLocationHost(
                        result?.rewardInfo.rewardIconUrl
                      )}
                      alt=""
                    />
                  </div>
                  <RiveComponent
                    src={`${appPath}/riv/background-light.riv`}
                    className={`${styles['base-canvas-size']} ${styles['draw-content']}`}
                  />

                  <RiveComponent
                    src={`${appPath}/riv/confetti.riv`}
                    className={`${styles['base-canvas-size']} ${styles['draw-content']}`}
                  />
                </div>
              </div>
            ) : (
              <div className="flex justify-center">
                <img className="w-50 h-50" src={drawNoWin} alt="" />
              </div>
            )}
            {result?.rewardStatus ? (
              <p className="relative -top-4 text-4hxl font-semibold">
                {result?.rewardInfo.rewardContent +
                  result.rewardInfo.rewardSymbol}
              </p>
            ) : (
              <p className="mt-8 text-gray1 text-2xl font-semibold text-center">
                {failTitle}
              </p>
            )}
            <div className="relative flex flex-col items-center mt-8">
              <Button
                className=" w-[300px] !h-[48px]"
                key="confirm"
                variant="primary"
                onClick={props.onOk}
              >
                {result?.rewardStatus ? fm('viewReward') : fm('word_ok')}
              </Button>
              {Boolean(result?.rewardStatus) && (
                <Button
                  className="mt-4 w-[300px] !h-[48px] bg-black"
                  key="reset"
                  variant="secondary"
                  onClick={props.onShare}
                >
                  {fm('share')}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  );
}
